const navData = {
  navItems: [
    {
      navTitle: 'Home',
      navLink: '#home',
      sectionId: 'home',
    },
    {
      navTitle: 'About Me',
      navLink: '#about',
      sectionId: 'about',
    },
    {
      navTitle: 'Skills',
      navLink: '#skills',
      sectionId: 'skills',
    },
    {
      navTitle: 'Experience',
      navLink: '#experience',
      sectionId: 'experience',
    },
    {
      navTitle: 'Contact',
      navLink: '#contact',
      sectionId: 'contact',
    },
  ],
};

export default navData;
